import { render, staticRenderFns } from "./CreateMaterial.vue?vue&type=template&id=4ec95d54&scoped=true&"
import script from "./CreateMaterial.vue?vue&type=script&lang=ts&"
export * from "./CreateMaterial.vue?vue&type=script&lang=ts&"
import style0 from "./CreateMaterial.vue?vue&type=style&index=0&id=4ec95d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec95d54",
  null
  
)

export default component.exports